import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SittingAreaIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SittingAreaIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.4101 14.0109V12.7411C19.4101 11.6666 18.531 10.7875 17.4566 10.7875H11.1595L9.83109 3.90442C9.65527 2.98624 8.84779 2.32202 7.91658 2.32202H6.38628C6.19092 2.32202 6.00859 2.40668 5.88486 2.55645C5.76113 2.70622 5.70904 2.89507 5.74811 3.08392L7.67564 14.0435L6.3993 21.0894C6.33418 21.4411 6.56861 21.7797 6.92677 21.8448C6.95933 21.8578 6.9984 21.8578 7.03747 21.8578C7.34353 21.8578 7.62354 21.6364 7.67564 21.3238L8.05333 19.253H18.5766L18.7589 21.2652C18.7915 21.6039 19.0715 21.8578 19.4101 21.8578H19.4687C19.8269 21.8253 20.0939 21.5062 20.0613 21.148L19.4101 14.0109ZM7.91657 3.62441C8.22914 3.62441 8.49613 3.84582 8.55474 4.15188L9.98085 11.5625C10.0395 11.8685 10.3064 12.0899 10.619 12.0899H17.4565C17.8147 12.0899 18.1077 12.383 18.1077 12.7411V13.3923H8.88685L7.16119 3.62441H7.91657ZM8.29426 17.9507L8.88685 14.6947H18.1663L18.4594 17.9507H8.29426Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SittingAreaIcon;
